function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6e6e6e;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M5,13a1,1,0,0,0-1,1V26a3,3,0,0,0,3,3H25a3,3,0,0,0,3-3V15a1,1,0,0,0-2,0V26a1,1,0,0,1-1,1H21V24a3,3,0,0,0-3-3H14a3,3,0,0,0-3,3v3H7a1,1,0,0,1-1-1V14A1,1,0,0,0,5,13Zm8,11a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v3H13Z",
  transform: "translate(-2 -2)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M29,12a1,1,0,0,0,.525-1.852l-13-8a1,1,0,0,0-1.049,0l-13,8a1,1,0,1,0,1.049,1.7L16,4.174l12.476,7.678A1,1,0,0,0,29,12Z",
  transform: "translate(-2 -2)"
});

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.001,
    height: 27,
    viewBox: "0 0 28.001 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.887193b2.svg";
export { ForwardRef as ReactComponent };